<script>
  import { createEventDispatcher } from 'svelte';
  import { categories, raceResultsStore as data, races } from '../stores';
  import { scale } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  export let isOpenModal = false;
  export let riderRaces;
  export let riderId;

  let riderCategory = "";

  function addOverallRaceRanks() {
    const allData = JSON.parse(JSON.stringify($data));
    //console.log(riderId);
    $races.forEach(race => {
      
      let raceData = allData.filter(item => parseInt(item.ri) === parseInt(race.id));
      //console.log(raceData);
      
    })

  }

  addOverallRaceRanks();
  function showTotalPoints(riderRaces) {
    let totalPoints = 0;
    
    riderRaces.forEach(item => {
      totalPoints = totalPoints + parseInt(item.p);  
    });
    return totalPoints;
  }

  const dispatch = createEventDispatcher();

  const closeModal = () => {
    isOpenModal = false;
    dispatch('closeModal', { isOpenModal });
  }
</script>

{#if isOpenModal}
<div style="display: none;">
  {riderCategory = $categories.filter(item => item.id == riderRaces[0].ci)[0].name}  
</div>
<div id="background" style="display: {isOpenModal ? 'block' : 'none'};" on:click={closeModal}></div>
<div transition:scale="{{duration: 250, delay: 10, opacity: 0.5, start: 0.5, easing: quintOut}}" id="modal" style="--display: {isOpenModal ? 'block' : 'none'};">
    <div>
        <div class="modal-header text-capitalize bg-dark text-white">
          <div style="float:left;">
            <h5 class="modal-title fw-bold text-start text-uppercase fs-6">{riderRaces[0].n}</h5>
            <p class="modal-title text-start text-danger fs-6">{riderCategory}</p>
          </div>
        </div>
        <table class="table table-borderless align-middle" style="font-size: 0.75rem;">
          <thead>
            <tr>
              <th scope="col">RACE</th>
              <th class="name_style" scope="col">POSITION</th>
              <th scope="col">TIME</th>
              <th scope="col">POINTS</th>
            </tr>
          </thead>
          <tbody>
            {#each riderRaces as race}
              <tr>
                <td class="align-middle">#{race.ri}</td>
                <td class="align-middle">{race.r}</td>
                <td class="align-middle">{race.t}</td>
                <td class="align-middle text-success">{race.p}</td>          
              </tr>
            {/each}
              <tr>
                <td class="align-middle">&nbsp;</td>
                <td class="align-middle">&nbsp;</td>
                <td class="align-middle">&nbsp;</td>
                <td class="fs-6"><span class="badge bg-success text-dark">{showTotalPoints(riderRaces)}</span></td>
              </tr>
          </tbody>
        </table>
        
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger btn-sm" on:click={closeModal}>
          CLOSE
        </button>
      </div>
      
</div>
{/if}

<style>
  #background {
        display: var(--display);
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(65, 65, 65, 0.66)
    }

    #modal {
        display: var(--display);
        /*width: 90%;*/
       	position: fixed;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #FFF;
        color: black;
        filter: drop-shadow(0 0 20px #333);
        
        /*border: 1px solid #FFF; */
        border-radius: 5px;
        
    }
</style>